import { Injectable } from '@angular/core';
import { DiffApi } from 'src/app/api/observations/diff.api';
import { DiffObservationSection } from 'src/app/model/enum/observations/diff/diff-observation-section.enum';
import { DiffActionPlanDTO } from 'src/app/model/observation/diff/diff-action-plan-dto.model';
import { CreateObservationDTO } from 'src/app/model/observation/diff/diff-create-dto.model';

@Injectable({
    providedIn: 'root'
})
export class DiffService {
    constructor(private diffApi: DiffApi) { }


    createDiff = (diffCreateDto: CreateObservationDTO) =>
        this.diffApi.createDiff(diffCreateDto);

    getObservationDetails = (userId: string, diffId: string) =>
        this.diffApi.getDetails(userId, diffId);

    updateActionPlan = (actionPlan: DiffActionPlanDTO) =>
        this.diffApi.updateActionPlan(actionPlan);

    submitActionPlan = (actionPlan: DiffActionPlanDTO) =>
        this.diffApi.submitActionPlan(actionPlan);

    submitDiff = (diffObservationId: string, section: DiffObservationSection) =>
        this.diffApi.submitDiff(diffObservationId, section);

    submitSignature = (diffObservationId: string, signature: string) =>
        this.diffApi.submitSignature(diffObservationId, signature);

    unauthenticate = (diffObservationId: string) =>
        this.diffApi.unauthenticate(diffObservationId);

    submitFeedback = (diffObservationId: string) =>
        this.diffApi.submitFeedback(diffObservationId);
}
